import axios from "axios";
import Cookies from "js-cookie";
import { refreshAccessToken, clearAccessToken } from '@/auth/token';

// создаем экземпляр axios для запросов внутри лк(после логина)
export const api = axios.create({
  timeout: 20000
});

// создаем слушатель запросов, добавляем заголовки к каждому запросу
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('accessToken');

    config.headers = config.headers || {};

    if (token) {
      config.headers["Content-Type"] = 'application/json';
      config.headers.Authorization = `Bearer_${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)

// глобальный lock для обновления токена. Если много запросов получили 401, то сначала обновим токен после одного запроса, 
// затем последующие запросы будем выполнять уже с обновленным токеном
let refreshPromise = null;

// создаем слушатель ответов от сервера
api.interceptors.response.use(

  // Случай штатной отработки
  (response) => {
    return response;
  },

  // Случай получения >200 кода
  async (error) => {
    console.error(error);
    // Если сервер недоступен
    if (!error.response) {
      return Promise.reject(error);
    }

    const status = error.response.status;
    const originalRequest = error.config; 

    if (status !== 401) {
      return Promise.reject(error);
    }

    // Защита от бесконечного цикла рефреша
    if (originalRequest._retry) {
      return Promise.reject(error);
    }
    originalRequest._retry = true;

    try {
      if (!refreshPromise) {
        refreshPromise = refreshAccessToken().finally(() => {
          refreshPromise = null;
        });
      }

      const refreshResult = await refreshPromise;

      if (!refreshResult.success) {
        clearAccessToken();
        window.location.href = "/login";
        return Promise.reject(error)
      }

      const newToken = Cookies.get('accessToken');

      // здесь возможно понадобиться обновить в заголовке токен
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.Authorization = `Bearer_${newToken}`;

      return api(originalRequest);
    } catch (error) {
      console.error(error)
      clearAccessToken();
      window.location.href = "/login";
      return Promise.reject(error);
    }
  }
)